module.exports = __webpack_public_path__ + "static/media/icon16.c79594a2.png";